import { mountRequest } from 'reactApp/modules/modifying/modifying.actions';
import { store as reduxStore } from 'reactApp/store';

import { getSelectedItems } from './helpers/getSelectedItems';

export const mount = (): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state);
    const item = selectedItems.length === 1 && selectedItems[0];

    if (!item) {
        return;
    }

    // @ts-ignore
    reduxStore.dispatch(mountRequest({ item }));
};
